import { fromJS } from 'immutable';

export default {
    setSDM18MVRs: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateSDM18MVRs: (state, products) => {
        return state.mergeIn(['list'], fromJS(products));
    },
    setSDM18MVRDetails: (state, productId, product) => {
        return state.setIn(['list', productId], fromJS(product));
    },
    updateSDM18MVRStatus: (state, productId, status) => {
        return state.setIn(['list', productId, 'state'], status);
    },
    switchSDM18MVRMaster: (state, productId, masterId) => {
        return state.setIn(['list', productId, 'userMasterId'], masterId);
    },
    dissociateUserFromSDM18MVR: (state, productId, userId) => {
        if (state.getIn(['list', productId, 'userMasterId']) === userId) {
            state = state.deleteIn(['list', productId, 'userMasterId']);
        }
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    },
    dissociateUserFromSDM18MVRAndSwitchMaster: (state, productId, userId, masterId) => {
        state = state.setIn(['list', productId, 'userMasterId'], masterId);
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18MVR/core.js